/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable radix */
/* eslint-disable no-alert */
var ezdia;
(function (ezdia) {
    var HtmlTemplates = ezdia.templates.dashboard;
    function createSearch(obj) {
        if (obj.query === 'null') {
            return '';
        }
        var widget = this.options.widgets;
        var fields = ezdia.util.jsonParse(obj.query);
        var fieldsNameMap = {};
        var tab = null;
        if (!fields) {
            return '';
        }
        $.each(fields, function (i, o) {
            var arr = [];
            var config = o.config || o.configMap || {};
            var options;
            ezdia.util.getFormatedConfigObject(o);
            o.edittype = o.type;
            o.editable = true;
            if (o.type === 'textfield' ||
                o.type === 'text' ||
                o.type === 'group' ||
                o.type === 'role' ||
                o.type === 'date' ||
                o.type === 'tag') {
                if (o.type === 'group' || (o.type === 'role' && config.url)) {
                    widget.group.push({ column: o, id: o.name, metadata: config });
                }
                else if (o.type === 'date') {
                    widget.date[o.name] = o;
                }
                else if (o.type === 'tag') {
                    widget.tag.push({
                        column: o,
                        id: o.name,
                        metadata: config,
                        edittype: o.type
                    });
                }
                o.type = 'text';
            }
            else if (o.type === 'visualstatus' ||
                o.type === 'status' ||
                o.type === 'singlechoice') {
                o.addon = o.addon || '';
                options = config.options || {};
                $.each(options, function (idx, mval) {
                    if (idx) {
                        arr.push({
                            value: idx,
                            label: mval
                        });
                    }
                });
                o.options = arr;
                o.type = 'select';
                widget.select.push(o.name);
            }
            fieldsNameMap[o.name] = o.dbName;
        });
        tab = ezdia.util.sanitizer.specialChar(obj.pagename || obj.name);
        return {
            id: obj.id + "-search",
            fields: fields,
            fieldsNameMap: fieldsNameMap,
            name: obj.name,
            account: obj.account || '',
            tab: tab.toLowerCase()
        };
    }
    function widgets() {
        var widget = this.options.widgets;
        var date = widget.date, group = widget.group, select = widget.select, tag = widget.tag;
        if (!$.isEmptyObject(date)) {
            createDateField(date);
        }
        if (group.length) {
            $.ezdia.typehead.create(group);
        }
        if (tag.length) {
            $.ezdia.tagInput.create(tag);
        }
        if (select.length) {
            $.each(select, function each(i, name) {
                var elem = $("#" + name);
                var len = elem.find('option').length;
                var value = this.value;
                elem
                    .on('click', function () {
                    elem.removeClass('placeholder');
                })
                    .on('blur, change', function blur() {
                    var values = this.value;
                    if (values) {
                        elem.removeClass('placeholder');
                    }
                    else {
                        elem.addClass('placeholder');
                    }
                });
                if (value) {
                    elem.removeClass('placeholder');
                }
                else {
                    elem.addClass('placeholder');
                }
                if (len > 5) {
                    elem.selectmenu();
                }
            });
        }
    }
    var resetSelectMenu = function (select) {
        $.each(select, function each() {
            var elem = $(this);
            var len = elem.find('option').length;
            if (len > 5) {
                elem.selectmenu('updateValue', '');
            }
            else {
                elem.val('');
            }
        });
    };
    var resetTagMenu = function (tag) {
        $.each(tag, function each() {
            var elem = $(this).next('input');
            elem.tagsinput('removeAll');
        });
    };
    function events() {
        $('#ez-dashboard-charts-nav-wrapper').on('click', 'a', $.proxy(this.renderOnClick, this));
        $('form[data-form="search"]').on('click', 'a[type="button"]', $.proxy(this.search, this));
        $('[data-chart="dropdown"]').on('click', 'a', $.proxy(this.chartMenus, this));
        $('[data-filter="filter"]').on('click', $.proxy(this.toggleFilter, this));
        $('.ez-expandall-collapseall').on('click', $.proxy(this.toggleExpandCollapse, this));
    }
    var wrapperGroupChart = function (grpObject, obj) {
        var id = $("#" + obj.id).empty();
        var template = HtmlTemplates.groupChartsWrapper;
        // eslint-disable-next-line consistent-return
        $.each(grpObject, function (i, grp) {
            if (!i) {
                return true;
            }
            var name = ezdia.util.sanitizer.specialChar(grp.name);
            grp.obj = {
                id: "ez-" + name + "-" + grp.wType,
                type: grp.wType,
                title: grp.title
            };
            id.append(template({
                id: grp.obj.id
            }));
        });
    };
    var getProjectName = function (name) {
        var project = null;
        if (name) {
            project = $('#ez-nav-left-projects').find("a[data-value=" + name + "]").text();
            project = project.trim();
        }
        return project;
    };
    var displayChartElements = function (charts, obj) {
        var selectedLink = null;
        var context = null;
        var currentBlock = null;
        if (charts.overview) {
            selectedLink = $('#ez-dashboard-charts-nav-wrapper').find('[data-name="overview"]');
            context = charts.overview;
            currentBlock = '#ez-dashboard-charts-overview';
        }
        else {
            selectedLink = $('#ez-dashboard-charts-nav-wrapper').find("[data-name=\"" + obj.link + "\"]");
            context = charts[obj.link];
            currentBlock = "#" + obj.div;
        }
        $(currentBlock).show();
        selectedLink.addClass('active').data('render', true);
        return context;
    };
    var createChartElements = function (obj, key, name) {
        var tab = $('<a>', {
            href: "#" + key,
            html: obj.pagename || obj.title,
            'data-name': name
        });
        var wrapper = $('<div>', {
            id: key,
            css: {
                display: 'none'
            }
        });
        $('#ez-dashboard-charts-nav-wrapper').append(tab);
        $('#ez-dashboard-charts-wrapper').append(wrapper);
        wrapper.append('<div class="ez-expandall-collapseall" data-value="1" >Collapse All</div>');
    };
    function checkPin(key) {
        return $.inArray(key, this.options.keys) !== -1;
    }
    function createChartsWrapper() {
        var config = $.ezdia.config.pageParams;
        var queries = config.queries || [];
        var self = this;
        var charts = $.data(document, 'ez.dashboard');
        var template = $.ezdia.template.get('dashboard-charts-wrapper', {
            'partial-dashboard-search': 'dashboard-chart-search'
        });
        var suffix = 'ez-dashboard-charts-';
        var firstKey = null;
        var tab = config.tab;
        var wrapper = null;
        var coltwo = {};
        if (tab !== 'Dashboard') {
            var arr_1 = [];
            var globalArray_1 = [];
            $.each(this.options.charts, function (i, obj) {
                if (obj.global) {
                    globalArray_1.push(obj);
                }
                else {
                    arr_1.push(obj);
                }
            });
            this.options.charts = $.merge(globalArray_1, arr_1);
        }
        $.each(this.options.charts, function each(i, obj) {
            var name = null;
            var key = null;
            var chartId = null;
            if (tab === 'Dashboard') {
                name = ezdia.util.sanitizer.specialChar(obj.pagename || obj.name);
                name = name.toLowerCase();
                key = suffix + name;
                if (!firstKey) {
                    firstKey = {
                        link: name,
                        div: key
                    };
                }
                if (!charts[name]) {
                    createChartElements(obj, key, name);
                }
                wrapper = $("#" + key);
                chartId = obj.name + config.account + config.role;
                if (queries.length) {
                    obj.pin = checkPin.call(self, chartId) ? 'unpin' : 'pin';
                }
                else {
                    obj.pin = 'pin';
                }
                obj.share = config.share;
            }
            else {
                chartId = obj.name + obj.account + obj.role;
                wrapper = $('#ez-dashboard-charts-wrapper');
                name = tab;
                if (!obj.global) {
                    obj.project = getProjectName(obj.account);
                    obj.pin = 'unpin';
                }
                else {
                    obj.share = config.share;
                    obj.export =
                        obj.type === 'task' || obj.type === 'html' ? false : config.export;
                    if (!obj.export && !config.share) {
                        obj.hideactions = true;
                    }
                }
            }
            if (!charts[name]) {
                charts[name] = [];
            }
            this.config = this.config || {};
            obj.layout = this.config.layout ? "col-layout-" + this.config.layout : '';
            obj.id = suffix + ezdia.util.sanitizer.specialChar(chartId);
            obj.search = obj.query ? createSearch.call(self, obj) : '';
            obj.shared = config.shared;
            obj.tab = tab;
            obj.export =
                obj.type === 'task' || obj.type === 'html' ? false : config.export;
            if ((obj.type === 'chart' || obj.type === 'task' || obj.type === 'html') &&
                coltwo[name]) {
                wrapper = $(coltwo[name]).closest('[data-row="wrapper"]');
                coltwo[name] = false;
                obj.norow = true;
            }
            else if ((obj.type === 'chart' || obj.type === 'task' || obj.type === 'html') &&
                !coltwo[name]) {
                coltwo[name] = "#" + obj.id;
            }
            wrapper.append(template(obj));
            charts[name].push(obj);
        });
        widgets.call(this);
        events.call(this);
        $('.ez-expandall-collapseall').show();
        return tab === 'Dashboard'
            ? displayChartElements(charts, firstKey)
            : charts[tab];
    }
    var createEmptyPage = function () {
        var template = HtmlTemplates.chartsEmpty;
        $('#ez-dashboard-charts-wrapper').html(template());
    };
    var emailShareLink = function (link) {
        var form = $('#ez-dhashboard-share-form');
        if (form.valid()) {
            var inputEl_1 = $('input#ez-dashboard-email-input');
            var data = "shareEmail=" + inputEl_1.val();
            data += "&shareLink=" + link;
            $.ajax({
                type: 'POST',
                url: 'emailShareDashboardLink.htm',
                data: data,
                dataType: 'json',
                success: function (response) {
                    inputEl_1.val('');
                    $('div#ez-dashboard-share-link-msg').html(response).fadeIn();
                }
            });
        }
    };
    var validateShareForm = function () {
        $('#ez-dhashboard-share-form').validate({
            rules: {
                emailLink: {
                    required: true,
                    ezEmail: true
                }
            },
            errorPlacement: function (error, element) {
                $.ezdia.validateForm.errorPlacement(error, element);
            },
            highlight: function (element) {
                $.ezdia.validateForm.highlight(element);
            },
            unhighlight: function (element) {
                $.ezdia.validateForm.unhighlight(element);
            }
        });
    };
    function displaySharedLink(data, error) {
        var options = $.ezdia.config.pageParams;
        var template = HtmlTemplates.shareItemsLink;
        var context;
        var href = null;
        var emailLink = null;
        var btns = [
            {
                text: 'Cancel',
                class: 'btn-link',
                click: function () {
                    $(this).dialog('close');
                }
            }
        ];
        if (error) {
            context = {
                message: data.ERROR,
                error: error
            };
        }
        else {
            emailLink = options.deskUrl + "ViewDashboard.htm?key=" + data.link + "%26accountName=" + options.account;
            href = options.deskUrl + "ViewDashboard.htm?key=" + data.link + "&accountName=" + options.account;
            context = {
                link: href,
                label: data.label,
                error: error
            };
            btns.push({
                text: 'Share',
                class: 'btn-primary',
                click: function () {
                    var embed = $('input[name="ez_dashboard_email_share_type"]:checked').val();
                    var link = "<a href=\"" + emailLink + "%26embed=" + embed + "\" target=\"_blank\">" + data.label + "</a>";
                    emailShareLink(link);
                }
            });
        }
        $('#statusMsg').html(template(context)).dialog({
            modal: true,
            title: 'Share Dashboard',
            width: 600,
            height: 400,
            buttons: btns
        });
        $('input#ez-dashboard-email-input').focus();
        $('input[name="ez_dashboard_email_share_type"]')
            .off('click')
            .on('click', function click() {
            var value = this.value;
            var previewLink = $('a#ez-dashboard-share-link-preview');
            var str = null;
            if (value === 'true') {
                str = href + "&embed=true";
            }
            else {
                str = href + "&embed=false";
            }
            previewLink.attr('href', str).text(str);
        });
        validateShareForm();
    }
    var getShareLink = function (single) {
        var options = $.ezdia.config.pageParams;
        var shareDashboardItems = '';
        var data = '';
        var selectedItems = null;
        if (single) {
            shareDashboardItems = single;
        }
        else {
            selectedItems = $('input[name="shareDashboardItem"]:checked');
            if (!selectedItems.length) {
                ezdia.alert('Warning', 'Please select at least one chart.');
                return;
            }
            selectedItems.each(function each() {
                shareDashboardItems += $(this).val() + ",";
            });
            shareDashboardItems = shareDashboardItems.slice(0, -1);
        }
        data = "&accountName=" + options.account;
        data += "&roleName=" + options.role;
        data += "&shareName=" + shareDashboardItems;
        $.ajax({
            type: 'POST',
            url: 'createShareDashboardLink.htm',
            data: data,
            dataType: 'json',
            success: function (response) {
                var context = {};
                var error = false;
                if (response.ERROR) {
                    error = true;
                    context = response;
                }
                else {
                    var itemMetaInfo = checkItemMetaInfo({
                        shareDashboard: {}
                    });
                    var itemName = itemMetaInfo.shareDashboard[response.link];
                    if (itemName) {
                        itemName = itemName.name.join(', ');
                    }
                    else {
                        itemName = '';
                    }
                    context = {
                        link: response.link,
                        label: itemName
                    };
                }
                displaySharedLink(context, error);
            },
            error: function (response) {
                displaySharedLink(response, true);
            }
        });
    };
    var shareMenuActions = function (e) {
        e.stopPropagation();
        var elem = $(e.currentTarget);
        var type = elem.data('click');
        var id = elem.data('id');
        var linkElem = $("#ez-shared-link-dashboard-" + id);
        if (type === 'email') {
            var data = {
                link: linkElem.data('key'),
                label: linkElem.text()
            };
            displaySharedLink(data, false);
        }
        else {
            createMobilePreview(e);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var shareSingleChart = function (e) {
        var elem = $(e.currentTarget);
        var type = elem.data('click');
        var id = elem.data('id');
        var linkElem = $("#ez-shared-link-dashboard-" + id);
        if (type === 'email') {
            var data = {
                link: linkElem.data('key'),
                label: linkElem.text()
            };
            displaySharedLink(data, false);
        }
        else {
            createMobilePreview(e);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var adjustTabWidth = function () {
        $('[data-pill="btn-group"]').each(function each() {
            var self = $(this);
            if (self.parent().prop('scrollHeight') > 46) {
                var widths_1 = 0;
                $.each(self.find('a'), function eacha() {
                    widths_1 += $(this).outerWidth();
                });
                self.css('width', widths_1);
            }
        });
    };
    var createSearchSelectMenu = function () {
        // $('#ez-basic-search-row-wrapper')
        //   .find('select')
        //   .each(function each() {
        //     if ((this as HTMLSelectElement).options.length <= 5) {
        //       return;
        //     }
        //   });
    };
    var setBodyHeight = function () {
        var windowHeight = $(window).height();
        var nav = $('#ez-page-nav-left');
        var navHeight = nav.css('bottom', 'auto').outerHeight();
        var height = 0;
        if (windowHeight > navHeight) {
            height = windowHeight;
        }
        else {
            height = navHeight;
        }
        $('#ez-page-content-wrapper').css('min-height', height);
        nav.css('bottom', 0);
    };
    var exportGroupChart = function (obj) {
        var charts = $("#" + obj.id).find('[data-chart="groupchart"]');
        var arr = [];
        $.each(charts, function each() {
            var chart = $(this).highcharts();
            arr.push(chart);
        });
        $.ezdia.chart.export(arr);
    };
    // tslint:disable-next-line:no-empty
    var exportGlobalCharts = function (obj) {
        //
    };
    var exportSingleChart = function (obj) {
        var chart = $("#" + obj.id).highcharts();
        var container = $(chart.container);
        chart.exportChart({
            type: 'application/png',
            filename: obj.filename,
            width: container.width()
        });
    };
    var exportCharts = function (obj) {
        switch (obj.type) {
            case 'groupchart':
                exportGroupChart(obj);
                break;
            case 'global':
                exportGlobalCharts(obj);
                break;
            default:
                exportSingleChart(obj);
                break;
        }
    };
    function exportGridFormValue(frm) {
        if (frm) {
            return frm.serialize();
        }
        if (this.id) {
            var id = this.id.replace('grid_', '') + "-search";
            // eslint-disable-next-line no-param-reassign
            frm = $("#" + id);
            return frm ? frm.serialize() : '';
        }
        return '';
    }
    function exportGrid(e, name, id, frm) {
        exportValueFiler = exportGridFormValue.call(this, frm);
        var options = $.ezdia.config.pageParams;
        var $preparingFileModal = $('#preparing-file-modal');
        var p = this.p || {};
        var url = "exportDashbordData.htm?queryName=" + (name || p.name) + "&" + (typeof exportValueFiler === 'undefined' ? '' : exportValueFiler);
        var grid = null;
        var account = '';
        var role = '';
        if (name) {
            grid = $("#grid_" + id);
        }
        else {
            grid = $(this);
        }
        var getGridParam = grid.jqGrid('getGridParam');
        if (!getGridParam.global) {
            account = getGridParam.account || options.account || '';
            role = getGridParam.role || options.role || '';
        }
        $.fileDownload(url, {
            preparingMessageHtml: 'We are preparing your report, please wait...',
            // failMessageHtml: 'There was a problem generating your report, please try again.',
            httpMethod: 'POST',
            datatype: 'json',
            data: {
                accountName: function () {
                    return escape(account);
                },
                role: function () {
                    return escape(role);
                },
                columnValue: function () {
                    var column = getGridParam.colModel;
                    var arr = [];
                    $.each(column, function (i, obj) {
                        if (!obj.hidden) {
                            arr.push(obj.name);
                        }
                    });
                    return arr.join(',');
                },
                globalFlag: function () {
                    if (options.tab === 'GlobalDashboard') {
                        return true;
                    }
                    return false;
                }
            },
            successCallback: function () {
                // $preparingFileModal.dialog('close');
            },
            failCallback: function (response) {
                var responseHtml = response;
                var failMessageHtml;
                if (typeof responseHtml === 'string') {
                    var noHTML = /(<([^>]+)>)/gi;
                    responseHtml = responseHtml.replace(noHTML, '');
                    responseHtml = ezdia.util.jsonParse(responseHtml);
                    if (responseHtml && responseHtml.success) {
                        failMessageHtml = responseHtml.success;
                        ezdia.alert('Success', failMessageHtml);
                    }
                    else {
                        failMessageHtml =
                            'There was a problem generating your report, please try again.';
                        ezdia.alert('Error', failMessageHtml);
                        // $preparingFileModal.dialog('close');
                    }
                }
                else {
                    failMessageHtml =
                        'There was a problem generating your report, please try again.';
                    ezdia.alert('Error', failMessageHtml);
                    // $preparingFileModal.dialog('close');
                }
                $('#error-modal').dialog({ modal: true });
            }
        });
    }
    // eslint-disable-next-line consistent-return
    function pinCharts(obj) {
        return __awaiter(this, void 0, void 0, function () {
            var queryName, action, config, query, str, queryStr, account, role, data, q, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryName = obj.name;
                        action = obj.action;
                        config = $.ezdia.config.pageParams;
                        query = config.queries || [];
                        str = JSON.stringify(query);
                        queryStr = null;
                        account = config.account, role = config.role;
                        data = {
                            accountName: 'all',
                            role: 'all',
                            email: config.email,
                            action: 'pinnedquery'
                        };
                        if (config.tab === 'GlobalDashboard') {
                            account = obj.account;
                            role = obj.role;
                        }
                        if (action === 'unpin') {
                            // eslint-disable-next-line consistent-return
                            $.each(query, function (i, mval) {
                                if (mval.chartName === queryName &&
                                    mval.accountName === account &&
                                    mval.role === role) {
                                    query.splice(i, 1);
                                    return false;
                                }
                            });
                        }
                        else if (action === 'pin') {
                            q = {
                                chartName: queryName,
                                accountName: config.account,
                                role: config.role
                            };
                            query.push(q);
                        }
                        queryStr = JSON.stringify(query);
                        this.options.pinObj = obj;
                        if (queryStr === str) {
                            $.ezdia.dashboard.pinSuccess(config.tab, true);
                            return [2 /*return*/, false];
                        }
                        this.options.pinObj.query = query;
                        data.columnValue = queryStr;
                        data.tab = 'GlobalDashboard';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ezdia.util.saveUserSettings(data)];
                    case 2:
                        _a.sent();
                        $.ezdia.dashboard.pinSuccess(config.tab);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function createPinChartKeys() {
        var queries = $.ezdia.config.pageParams.queries;
        var self = this;
        $.each(queries, function (i, obj) {
            var keys = obj.chartName + obj.accountName + obj.role;
            self.options.keys.push(keys);
        });
    }
    var circleProgress = function (elem) {
        elem.find('[data-percentage]').each(function each() {
            var self = $(this);
            var fill = self.data('color') || '#999';
            var percent = self.data('percentage');
            self.circleProgress({
                startAngle: -Math.PI / 2,
                value: percent / 100,
                thickness: 6,
                fill: {
                    color: fill
                },
                size: 64,
                emptyFill: 'rgba(0, 0, 0, .1)'
            });
        });
    };
    var sortProjectsList = function () {
        var wrapper = $('#ez-nav-left-projects').sortItems({
            items: 'ul'
        });
        wrapper.find('ul').each(function each() {
            $(this).sortItems({
                items: '[data-list=sort]'
            });
        });
        wrapper.basicSearchAccount('MyAccount.htm').show();
    };
    function addCustomButton(gridProp, configProp) {
        var config = configProp;
        var options = $.ezdia.config.pageParams;
        config = config ? ezdia.util.jsonParse(config) : null;
        var grid = $(gridProp).find('.ui-jqgrid-btable');
        var iCol = getColumnIndexByName(grid, config.fieldName.toLowerCase());
        $(grid)
            .find(">tbody>tr.jqgrow>td:nth-child(" + (iCol + 1) + ")")
            .each(function each() {
            // tslint:disable-next-line: radix
            if (parseInt($(this).find('div').text())) {
                $('<span>', {
                    click: function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        sendToOptimisation(this, options, config);
                    }
                })
                    .addClass('btn-send-to-optimization')
                    .html('Send')
                    .appendTo($(this).children('div'));
            }
        });
    }
    function sendToOptimisation(element, options, config) {
        var batchIDValue = encodeURIComponent($(element).closest('tr').find('td')[1].innerText);
        var filterLabel = config.queryName + "_" + config.batchIDLabel + "_" + options.account + "_" + options.role;
        $.ajax({
            type: 'POST',
            url: "customHandler.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + config.queryName + "&action_handler=" + config.action_handler + "&" + filterLabel + "=" + batchIDValue + "&viewFlag=true",
            dataType: 'json',
            success: function (response) {
                renderContentHealthPopUp(response, element, options, config);
            }
        });
    }
    function getColumnIndexByName(grid, columnName) {
        var cm = grid.jqGrid('getGridParam', 'colModel');
        var i;
        var l = cm.length;
        for (i = 0; i < l; i++) {
            if (cm[i].name.toLowerCase() === columnName) {
                return i; // return the index
            }
        }
        return -1;
    }
    function renderContentHealthPopUp(response, element, options, config) {
        // eslint-disable-next-line no-param-reassign
        response = response.msg;
        if (response) {
            response.id = response.name;
            response.account = response.accountName;
            response.global = false;
            response.config = config;
            response.config.optimise = false;
            response.url = "customHandler.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + config.queryName + "&action_handler=" + config.action_handler + "&viewFlag=true";
            $.data(document, 'ez.contentHealthConfig', response);
            ezdia.widgets.contentHealthAnalysis.showContentHealthReport(element, response);
            dashboardObj.createGrid(response, response);
        }
        else {
            ezdia.util.showSuccessError({
                message: 'There was a problem while fetching this information. Please try again!',
                error: true,
                autohide: false
            });
        }
    }
    function invokeColumnAction(element) {
        var data = $(element).data('params');
        var action = $(element).data('action');
        var wrapper = ezdia.util.getWrapper('ez-grid-column-action-wrapper');
        $.ajax({
            type: 'POST',
            url: action,
            data: data,
            dataType: 'json',
            success: function (response) {
                var msg = response.msg, success = response.success;
                var upadteMsg = '';
                if (success) {
                    upadteMsg = msg || 'Your request is processed successfully!';
                }
                else {
                    upadteMsg =
                        msg ||
                            'Error occurred while processing your request. Please try again!';
                }
                wrapper.html(upadteMsg).dialog({
                    modal: true,
                    title: 'Checkout Item',
                    width: 400,
                    height: 150,
                    buttons: [
                        {
                            text: 'OK',
                            class: 'btn-primary',
                            click: function () {
                                $(this).dialog('close');
                            }
                        }
                    ]
                });
            },
            error: function () {
                //
            }
        });
    }
    var dashboardObj = {
        options: {
            charts: [],
            pinObj: {},
            pinWrapperId: 'ez-dashboard-pin-msg-wrapper',
            keys: [],
            widgets: {
                date: {},
                group: [],
                select: [],
                tag: []
            }
        },
        load: function () {
            var config = $.ezdia.config.pageParams;
            var queries = ezdia.util.jsonParse(config.queries) || {};
            var shared = config.shared;
            var charts = null;
            $.ezdia.config.pageParams.queries = queries;
            $.data(document, 'ez.dashboard', {});
            createPinChartKeys.call(this);
            sortProjectsList();
            setBodyHeight();
            $('#ez-role').basicSearchRole('MyAccount.htm');
            $('#ez-dashboard-create-share-items').on('click', $.proxy(this.shareItems.create, this));
            $.ezdia.leftNavToogle();
            createSearchSelectMenu();
            if ($.isEmptyObject(this.options.charts)) {
                createEmptyPage();
            }
            else {
                charts = createChartsWrapper.call(this);
                this.renderCharts(charts);
                if (!shared && config.share) {
                    this.shareItems.render();
                }
            }
            pageLoadingDone();
            this.onresize();
            $('body').on('click', '[data-type="addProduct"]', function click() {
                ezdia.widgets.contentHealthAnalysis.addProductsDialog(this);
            });
            $('body').on('click', '[data-type="sendForProdOptimization"]', function click() {
                ezdia.widgets.contentHealthAnalysis.sendForProdOptimization(this);
            });
            $('body').on('click', '.ez-grid-column-action', function click(event) {
                event.stopPropagation();
                event.preventDefault();
                invokeColumnAction(this);
            });
        },
        renderCharts: function (charts) {
            if (!charts) {
                return;
            }
            var self = this;
            $.each(charts, function (i, obj) {
                if (obj.type === 'groupchart') {
                    self.groupChartCall(obj.url, obj);
                }
                else {
                    self.ajaxCall(obj.url, obj);
                }
            });
        },
        renderOnClick: function (e) {
            e.preventDefault();
            var elem = $(e.currentTarget);
            if (elem.hasClass('active')) {
                return;
            }
            var href = elem.attr('href');
            var name = elem.data('name');
            var render = elem.data('render');
            var charts = null;
            elem.addClass('active').siblings().removeClass('active');
            $(href).show().siblings().hide();
            if (!render) {
                charts = $.data(document, 'ez.dashboard');
                charts = charts[name];
                this.renderCharts(charts);
                elem.data('render', true);
            }
        },
        ajaxCall: function (url, obj, search) {
            var self = this;
            if (obj.type === 'geochart') {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function (resp) {
                        var response = resp.dashboard[0];
                        $.ezdia.chart.create(response, obj);
                    }
                });
            }
            else {
                $.ajax({
                    url: url,
                    dataType: 'json',
                    success: function (resp) {
                        var response = resp.dashboard[0];
                        switch (obj.type) {
                            case 'grid':
                            case 'summary':
                            case 'analytics':
                                self.createGrid(response, obj);
                                break;
                            case 'rss':
                                $.ezdia.rss(response, obj);
                                break;
                            case 'task':
                                self.taskList(response, obj);
                                break;
                            case 'html':
                            case 'url':
                                self.htmlCard(response, obj);
                                response.config = response.config
                                    ? ezdia.util.jsonParse(response.config)
                                    : '';
                                if (response.config && response.config.parent) {
                                    $("#ez-dashboard-charts-" + obj.name)
                                        .find('.ez-grp-heading-grid')
                                        .html(response.title);
                                }
                                break;
                            default:
                                $.ezdia.chart.create(response, obj);
                                break;
                        }
                        if (search) {
                            self.searchApplied(search);
                        }
                    },
                    error: function (response) {
                        switch (obj.type) {
                            case 'grid':
                            case 'summary':
                            case 'analytics':
                                self.createGrid(response, obj);
                                break;
                            case 'rss':
                                $.ezdia.rss(response, obj);
                                break;
                            case 'task':
                                self.taskList(response, obj);
                                break;
                            case 'html':
                            case 'url':
                                self.htmlCard(response, obj);
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        },
        groupChartCall: function (url, obj, search) {
            var self = this;
            $.ajax({
                url: url,
                dataType: 'json',
                success: function (response) {
                    wrapperGroupChart(response.dashboard, obj);
                    $.ezdia.chart.groupChart(response.dashboard, obj);
                    if (search) {
                        self.searchApplied(search);
                    }
                },
                error: function () {
                    $.ezdia.chart.noData("#" + obj.id);
                }
            });
        },
        createGrid: function (data, obj) {
            var config = obj.config || {};
            var rowNum = config.rowNum || 30;
            var rowList = [10, 20, 30, 100, 400, 500];
            var col = data.colModel ? $.parseJSON(data.colModel) : null;
            var colNames = data.colNames ? $.parseJSON(data.colNames) : null;
            var resp = data.response ? $.parseJSON(data.response) : null;
            var template = HtmlTemplates.gridWrapper;
            var context = {
                tableId: "grid_" + obj.id,
                footerId: "footer_" + obj.id
            };
            var gridid = "" + context.tableId;
            if (rowNum) {
                rowList.push(rowNum);
            }
            else {
                rowNum = 10;
            }
            $("#" + obj.id).html(template(context));
            if (col && resp.length > 0) {
                ezdia.component.grid.create({
                    id: gridid,
                    data: resp,
                    datatype: 'local',
                    colModel: col,
                    colNames: colNames,
                    rowNum: rowNum,
                    rowList: rowList,
                    caption: data.title,
                    name: data.name,
                    emptyrecords: 'No data to display',
                    pager: obj.id,
                    account: obj.account || '',
                    role: obj.role || '',
                    global: obj.global,
                    gridContainerId: obj.id,
                    loadComplete: this.loadComplete,
                    gridComplete: function () {
                        var wrap = $("#" + obj.id);
                        wrap.find('.grid-loading-content').remove();
                        wrap.append("<div class=\"grid-loading-content\"><span class=\"text\"><i class=\"fa fa-bar-chart\"></i><br>Loading...</span></div>");
                        if (obj.config && obj.config.optimise) {
                            addCustomButton("#" + obj.id, obj.config);
                        }
                    },
                    columnChooser: false,
                    refresh: false,
                    isDashboard: true,
                    nofooter: obj.nofooter
                });
            }
            else {
                $("#" + obj.id)
                    .addClass('ez-chart-empty')
                    .html('<i class="fa fa-table"></i> No data to display')
                    .closest('div[data-row="panel"]')
                    .addClass('ez-chart-empty-panel');
            }
        },
        loadComplete: function () {
            var $grid = $(this);
            var gridContainerId = $grid.jqGrid('getGridParam', 'gridContainerId');
            var nofooter = $grid.jqGrid('getGridParam', 'nofooter');
            var $gridContainer = $("#" + gridContainerId);
            var innerHeight = $gridContainer.innerHeight();
            var headerHeight = $gridContainer
                .find(".ui-jqgrid-htable")
                .outerHeight();
            var footer = $("#footer-grid_" + gridContainerId);
            var footerHeight = footer.outerHeight();
            var height = innerHeight - headerHeight - footerHeight;
            if (nofooter) {
                footer.hide();
            }
            $grid.jqGrid('setGridHeight', height + "px");
        },
        taskList: function (data, obj) {
            var options = $.ezdia.config.pageParams;
            var elem = $("#" + obj.id).removeClass('ez-chart-empty');
            var template = HtmlTemplates.chartsTaskList;
            var context = {
                global: []
            };
            var empty = true;
            // eslint-disable-next-line no-param-reassign
            data = data.response ? ezdia.util.jsonParse(data.response) : null;
            if (data) {
                $.each(data, function (i, mval) {
                    var link = mval['Title link'];
                    var status = mval.Status || '';
                    var projectName = mval['Project name'] || 'global';
                    if (link && !$.ezdia.ValidUrl(link)) {
                        link = options.CONTEXT_ROOT + "/" + link;
                    }
                    if (status.toLowerCase() === 'active') {
                        if (!context[projectName]) {
                            context[projectName] = [];
                        }
                        context[projectName].push({
                            title: mval.Title,
                            description: mval.Description,
                            count: mval.Count,
                            due_date: mval['Due date']
                                ? moment(mval['Due date']).fromNow()
                                : '',
                            status: mval.Status,
                            title_link: link
                        });
                        empty = false;
                    }
                });
                if (empty) {
                    elem.addClass('ez-chart-empty');
                    if (!obj.started) {
                        elem
                            .closest('div[data-row="panel"]')
                            .addClass('ez-chart-empty-panel');
                    }
                    context = {
                        error: true
                    };
                }
                obj.started = true;
                elem.html(template(context));
            }
        },
        htmlCard: function (data, obj) {
            var elem = $("#" + obj.id).removeClass('ez-chart-empty');
            var templateName = obj.config.template_name;
            // eslint-disable-next-line no-param-reassign
            data = data.response ? ezdia.util.jsonParse(data.response) : null;
            if (!data || !obj.config || !templateName) {
                this.empty(elem, obj);
                return;
            }
            var template = $.ezdia.template.get(templateName, null, true);
            elem.html(template(data));
            circleProgress(elem);
        },
        searchGrid: function (obj, frm, search) {
            exportValueFiler = frm.serialize();
            var self = this;
            var options = $.ezdia.config.pageParams;
            var url = "getWidgetView.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + obj.name + "&viewFlag=true";
            if (options.userManagement) {
                url += '&userManagement=true';
            }
            if (obj.global) {
                url += '&globalFlag=true';
            }
            $("#" + obj.id).addClass('grid-loading');
            $.ajax({
                url: url,
                dataType: 'json',
                data: frm.serialize(),
                success: function (response) {
                    $("#" + obj.id).removeClass('grid-loading');
                    var respObj = response.dashboard[0];
                    if (respObj && respObj.response) {
                        var dataObj = $.parseJSON(respObj.response);
                        if (dataObj && dataObj !== null) {
                            var id = $("#grid_" + obj.id);
                            id.jqGrid('clearGridData');
                            id.jqGrid('setGridParam', { data: dataObj });
                            id.trigger('reloadGrid');
                        }
                    }
                    if (search) {
                        self.searchApplied(search);
                    }
                }
            });
        },
        search: function (e) {
            var config = $.ezdia.config.pageParams;
            var elem = $(e.currentTarget);
            var formid = elem.data('id');
            var frm = elem.closest("#" + formid);
            var inputs = frm.find(':input');
            var btn = elem.data('btn');
            var empty = true;
            if (btn !== 'clear') {
                $.each(inputs, function each() {
                    var value = this.value;
                    if (value) {
                        empty = false;
                    }
                });
                if (empty) {
                    ezdia.alert('Alert!', 'Please select filter value');
                    return;
                }
            }
            var name = elem.data('name');
            var account = elem.data('account') || '';
            var tab = config.tab === 'GlobalDashboard'
                ? config.tab
                : elem.data('tab').toLowerCase();
            var obj = $.data(document, 'ez.dashboard')[tab];
            var url = null;
            if (!obj || elem.hasClass('disabled')) {
                return;
            }
            if (btn === 'clear') {
                // frm.find('input[type=text], textarea').val('');
                resetSelectMenu(frm.find('select'));
                resetTagMenu(frm.find('.bootstrap-tagsinput'));
                // frm.find(':input').trigger('change');
                $.each(frm.find('input'), function (i, ele) {
                    var $input = $(ele);
                    if ($input.data('type') && $input.data('type') !== 'text') {
                        $(ele).typeahead('val', '');
                    }
                    $input.val('').trigger('change');
                });
                if (!frm.data('clear')) {
                    return;
                }
                frm.data('clear', false);
            }
            else {
                frm.data('clear', true);
            }
            // eslint-disable-next-line consistent-return
            $.each(obj, function (i, chart) {
                var chartAccount = chart.account || '';
                if (chart.name === name && chartAccount === account) {
                    obj = chart;
                    return false;
                }
            });
            url = obj.url + "&" + frm.serialize();
            if (config.userManagement) {
                url += '&userManagement=true';
            }
            switch (obj.type) {
                case 'groupchart':
                    $.ezdia.chart.loading("#" + obj.id);
                    this.groupChartCall(url, obj, elem);
                    break;
                case 'grid':
                case 'summary':
                case 'analytics':
                    this.searchGrid(obj, frm, elem);
                    break;
                default:
                    $.ezdia.chart.loading("#" + obj.id);
                    this.ajaxCall(url, obj, elem);
            }
        },
        searchApplied: function (elem) {
            var btn = elem.data('btn');
            if (btn === 'clear') {
                return;
            }
            var toggleLabel = elem.data('toggleLabel');
            var label = elem.text();
            var frm = elem.closest('form');
            var inputs = frm.find(':input');
            elem
                .addClass('disabled')
                .data('toggleLabel', label)
                .find('span')
                .text(toggleLabel);
            inputs.on('change.ezDashboardSearchApplied', function () {
                elem
                    .removeClass('disabled')
                    .data('toggleLabel', toggleLabel)
                    .find('span')
                    .text(label);
                inputs.off('change.ezDashboardSearchApplied');
            });
        },
        shareItems: {
            create: function (e) {
                e.stopPropagation();
                var elem = $(e.currentTarget);
                var popup = elem
                    .popupList({
                    content: this.options.charts,
                    itemTemplate: 'dashboard-share-items-list',
                    buttonLabel: 'Cancel',
                    placement: function (context) {
                        $(context).multiItemCheckList();
                        return 'auto';
                    },
                    buttons: {
                        Share: function () {
                            getShareLink();
                            popup.popupList('destroy');
                        }
                    }
                })
                    .on('shown.bs.popover', function () {
                    var id = elem.attr('id');
                    var popover = $("#popover_" + id);
                    var offset = popover.offset();
                    var width = $(window).width();
                    var pwidth = popover.outerWidth();
                    var left = offset.left;
                    var twidth = left + pwidth;
                    if (twidth > width) {
                        var diff = twidth - width;
                        left -= diff;
                        popover.css({ left: left }).find('.arrow').css({ 'margin-left': diff });
                    }
                });
                $('body')
                    .off('.dashboardShareItemsListClick')
                    .on('click.dashboardShareItemsListClick', function click(event) {
                    var par = "#popover_" + popup.attr('id');
                    var isElem = popup.attr('id') === $(event.currentTarget).attr('id');
                    if (!$(event.target).parents(par).length && !isElem) {
                        popup.popupList('destroy');
                        $(this).off('.dashboardShareItemsListClick');
                    }
                });
            },
            render: function () {
                var config = $.ezdia.config.pageParams;
                var itemMetaInfo = checkItemMetaInfo({
                    shareDashboard: {}
                });
                var partial = {
                    item: 'shared-live-links-item',
                    sharedItemMenuMobile: 'shared-live-links-item-menu'
                };
                var template = $.ezdia.template.get('dashboard-shared-live-link', partial);
                var content = [];
                if (itemMetaInfo) {
                    $.each(itemMetaInfo, function (metaKey, metaValue) {
                        var context = {};
                        if (metaKey.match('shareDashboard') &&
                            !$.isEmptyObject(metaValue)) {
                            var count_1 = 0;
                            var tab = $('<a>', {
                                href: '#ez-shared_dashboard_charts',
                                text: 'Shared Charts',
                                'data-name': 'shared_dashboard_charts'
                            });
                            var wrapper = $('<div>', {
                                id: 'ez-shared_dashboard_charts',
                                css: {
                                    display: 'none'
                                }
                            });
                            $('#ez-dashboard-charts-nav-wrapper').append(tab);
                            $('#ez-dashboard-charts-wrapper').append(wrapper);
                            $.each(metaValue, function (key, value) {
                                if (key !== 'ERROR') {
                                    var link = config.deskUrl + "ViewDashboard.htm?key=" + key + "&accountName=" + config.account + "&embed=false";
                                    var email = config.deskUrl + "ViewDashboard.htm?key=" + key + "%26accountName=" + config.account;
                                    content.push({
                                        module: 'dashboard',
                                        key: key,
                                        label: value.name ? value.name.join(', ') : link,
                                        href: link,
                                        email: email
                                    });
                                    count_1 += 1;
                                }
                            });
                            context = {
                                module: 'dashboard',
                                count: count_1,
                                items: content
                            };
                            $('#ez-shared_dashboard_charts')
                                .html(template(context))
                                .on('click', 'a[data-click]', shareMenuActions);
                        }
                    });
                }
            }
        },
        chartMenus: function (e) {
            e.stopPropagation();
            e.preventDefault();
            var elem = $(e.currentTarget);
            var id = elem.attr('href');
            var action = elem.data('action');
            var type = elem.data('type');
            var title = elem.data('title');
            var name = elem.data('name');
            var account = elem.data('account');
            var role = elem.data('role');
            var formid = id + "-search";
            var frm = $("#" + formid);
            var obj = {
                elem: elem,
                action: action,
                title: title,
                name: name,
                account: account,
                role: role
            };
            switch (action) {
                case 'pin':
                    pinCharts.call(this, obj);
                    break;
                case 'unpin':
                    pinCharts.call(this, obj);
                    break;
                case 'download':
                    obj = {
                        id: id,
                        title: title,
                        type: type,
                        filename: "ezdia_" + title
                    };
                    if (obj.type === 'grid' ||
                        obj.type === 'summary' ||
                        obj.type === 'analytics') {
                        exportGrid('', name, id, frm);
                    }
                    else {
                        exportCharts(obj);
                    }
                    break;
                case 'share':
                    getShareLink(name);
                    break;
                default:
                    break;
            }
        },
        toggleFilter: function (e) {
            e.stopPropagation();
            var elem = $(e.currentTarget);
            var id = "#" + elem.data('id');
            var parent = $(id).parents('[data-chart="search"]');
            var $action = elem.parents('.action');
            $action.removeClass('open');
            parent.slideToggle();
            elem.toggleClass('ez-dashboard-filter-selected');
        },
        toggleExpandCollapse: function (event) {
            event.stopPropagation();
            var currentData = event.target.dataset.value;
            var $parent = $(event.target.parentElement);
            var $panelHeading = $parent.find('.panel-heading');
            var $panelBody = $parent.find('.panel-body');
            // 0 for collapsed, 1 for expanded
            if (parseInt(currentData, 10)) {
                // collapse the charts
                $panelHeading.addClass('collapsed');
                $panelBody.removeClass('in');
                $panelBody.css('height', '15px');
                event.target.dataset.value = 0;
                event.target.innerText = 'Expand All';
            }
            else {
                // expand the charts
                $panelHeading.removeClass('collapsed');
                $panelBody.addClass('in');
                $panelBody.css('height', 'auto');
                event.target.dataset.value = 1;
                event.target.innerText = 'Collapse All';
            }
        },
        pinSuccess: function (tab, error) {
            var options = this.options;
            var pinObj = options.pinObj;
            var title = pinObj.title;
            var errorType = !!error;
            var elem = pinObj.elem;
            var action = elem.data('action');
            var context = {
                error: errorType,
                duration: 10000
            };
            if (error) {
                if (action === 'pin') {
                    context.message = "<strong>Error</strong>! \"" + title + "\" chart is unable to be pinned to My Dashboard.";
                }
                else {
                    context.message = "<strong>Error</strong>! \"" + title + "\" chart is unable to be removed from My Dashboard.";
                }
            }
            else {
                var type = elem.data('type');
                $.ezdia.config.pageParams.queries = pinObj.query;
                if (action === 'pin') {
                    context.message = "<strong>Success</strong>! \"" + title + "\" chart successfully pinned to My Dashboard. Go to <a href=\"Home.htm\">My Dashboard</a>.";
                }
                else {
                    context.message = "<strong>Success</strong>! \"" + title + "\" chart successfully removed from My Dashboard.";
                }
                if (tab === 'Dashboard') {
                    if (action === 'pin') {
                        elem.data('action', 'unpin');
                    }
                    else {
                        elem.data('action', 'pin');
                    }
                    elem.toggleClass('unpin');
                }
                else if (type === 'chart' || type === 'task') {
                    elem.closest('div[data-row="column"]').remove();
                }
                else {
                    elem.closest('div[data-row="wrapper"]').remove();
                }
            }
            ezdia.util.showSuccessError(context);
        },
        onresize: function () {
            $(window).resize(function () {
                setBodyHeight();
            });
        },
        empty: function (elem, obj) {
            var msg = '<i class="fa fa-bar-chart-o"></i> No data to display';
            elem.addClass('ez-chart-empty').html(msg);
            if (!obj.started) {
                obj.started = true;
                elem.closest('[data-row="panel"]').addClass('ez-chart-empty-panel');
            }
        }
    };
    var pages;
    (function (pages) {
        pages.dashboard = dashboardObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.dashboard = dashboardObj;
})(ezdia || (ezdia = {}));
